import {copilot} from '@cl/shared';
import {CLDispatch} from 'common/src/redux/store';
import {AgentName} from '../../copilot.enums';
import {createChat as createChatAction} from '../copilot.slice';
import addWelcomeMessage from './utils/addWelcomeMessage';

function createSupportChat() {
  return (dispatch: CLDispatch) => {
    const chat = copilot.createSupportChat();
    const chatId = chat.id;

    dispatch(createChatAction({chatId, isPlanModeEnabled: false}));
    addWelcomeMessage(dispatch, chatId, AgentName.Support);

    return chatId;
  };
}

export default createSupportChat;
